// Satıcı künyesi, mesafeli satış sözleşmesi ve iptal/iade sayfalarında kullanılır.
//
// Ünvan, vergi dairesi ve vergi no hirethink.ai footer'ından alındı.
// MERSİS no kullanıcı tarafından verildi.
// Yalnızca KEP adresi eksik, zorunlu değil, verilirse sözleşmede otomatik görünür
// (isFilled kontrolü doldurulmamış alanları gizler).

export const COMPANY = {
  legalName: 'HireThink Yapay Zeka Teknolojileri A.Ş.',
  brand: 'isBulsun.com',
  address:
    'Bilişim Vadisi, Ayazağa, Vadi Istanbul Park Etabı, Kemerburgaz Caddesi D:7A Blok, 34475 Sarıyer / İstanbul',
  phone: '0850 307 80 61',
  email: 'info@hirethink.ai',
  taxOffice: 'Maslak',
  taxNumber: '4621090464',
  mersis: '0462109046400001',
  kep: '[DOLDURULACAK: KEP Adresi (varsa)]',
};

export const LAST_UPDATED = '1 Ağustos 2026';
export const LAST_UPDATED_EN = 'August 1, 2026';

// Doldurulmamış alanlar canlı sayfada "[DOLDURULACAK...]" olarak görünmesin
export const isFilled = (value) => Boolean(value) && !value.startsWith('[DOLDURULACAK');
